import { fromMedia, toMedia } from "@app/styles/helpers/mediaQueries";
import { gutter, rgbaCssVarColor } from "@app/styles/helpers/theme";

import { css } from "styled-components";
import { zIndex } from "@app/styles/variables/zIndex";

export const blueprintStyles = css`
    .bp5-popover {
        box-shadow: var(--dit-layout-shadow-select-input-popover--map);
    }

    .bp5-popover-content {
        border-radius: 0;

        img {
            max-width: 440px;
        }
    }

    .bp5-transition-container {
        z-index: ${zIndex.popoverMenu};
    }

    .bp5-overlay-backdrop {
        z-index: ${zIndex.overlay};
        background-color: ${rgbaCssVarColor("--dit-brand-color-neutral-100--map", 0.6)};
    }

    .bp5-toast-container {
        max-width: ${({ theme }) => theme.contentMaxWidth}px;
        margin: 0 auto;
    }

    .bp5-toast {
        && {
            position: fixed !important;

            &:not([class*="bp5-intent-"]) {
                background-color: var(--dit-brand-color-neutral-00--map);
                color: var(--dit-brand-color-informative-50);
                border: 1px solid var(--dit-brand-color-neutral-30--map);

                .bp5-button .bp5-icon {
                    color: var(--dit-brand-color-neutral-100--map);
                }
            }

            &[class*="bp5-intent"] {
                color: var(--dit-brand-color-neutral-00--map);
                .bp5-button .bp5-icon {
                    color: var(--dit-brand-color-neutral-00--map) !important;
                }
            }

            &.bp5-intent-success {
                background-color: var(--dit-brand-color-status-success-50--map);
            }

            &.bp5-intent-warning {
                background-color: var(--dit-brand-color-status-warning-50--map);
            }

            &.bp5-intent-danger {
                background-color: var(--dit-brand-color-status-alert-50--map);
            }
        }
    }

    .overlay-message-center {
        .bp5-overlay-content {
            z-index: ${zIndex.overlay};
            ${toMedia.MD`
                width: 260px;
            `}

            ${fromMedia.MD`
                width: 340px;
            `}

            ${({ theme }) => toMedia.XL`
                right: ${gutter(2)};
                top: calc(${gutter()} + ${theme.headerHeight}px);
            `}
        }
    }

    .bp5-dialog {
        background-color: var(--dit-brand-color-neutral-00--map);
        width: 665px;
        box-shadow: var(--dit-layout-shadow-dialog--map);
        border-radius: var(--dit-layout-radius-dialog--map);

        .bp5-dialog-header {
            background-color: var(--dit-brand-color-neutral-00--map);
            box-shadow: var(--dit-layout-shadow-dialog--map);

            h4.bp5-heading {
                color: var(--dit-layout-color-dialog-header--map);
                font-size: var(--dit-layout-font-size-dialog-header--map);
                font-weight: var(--dit-layout-font-weight-dialog-header--map);
                white-space: normal;
            }

            .bp5-dialog-close-button {
                background: var(--dit-brand-color-neutral-00--map);
                color: var(--dit-layout-color-dialog-close--map);
                padding: 1px 3px;
                margin: 10px;
                border-radius: 3px;

                svg {
                    color: var(--dit-layout-color-dialog-close--map);
                }
            }
        }
        .bp5-dialog-footer {
            text-align: center;
            margin-bottom: 20px;

            button {
                padding: 10px;
                margin: 10px;
            }

            .save-button {
                margin-right: 20px;
            }

            .cancel-button {
                background-color: var(--dit-components-color-button-tertiary-background) !important;
            }
        }
    }

    .bp5-dialog.confirm-deletion .bp5-dialog-footer button {
        padding: ${gutter(1)} ${gutter(2)};
    }

    .bp5-toast-container.bp5-toast-container-top {
        top: ${({ theme }) => theme.headerHeight}px;
    }

    //TODO: Remove styling override when we work on https://jira.equisoft.com/browse/DIT-7279
    .btn-secondary {
        &.btn-base {
            min-width: 126px;
        }
        .btn-secondary-label {
            text-align: center !important;
        }
    }

    :focus:not(:focus-visible) {
        outline-offset: 0;
        outline: 0;
        -moz-outline-radius: 0;
        ::-moz-focus-inner {
            border: 0;
        }
    }

    :focus {
        outline: none;
    }

    a:not(
        .btn-skip,
        .nav-link,
        .dit-components-btn-secondary,
        .dit-components-link,
        .application-number-link,
        .policynumber-link,
        .btn-usermenu-profile,

    ) {
        color: var(--dit-components-color-link);
        font-size: var(--dit-layout-font-size-link--map);

        &:visited {
            color: var(--dit-components-color-link-visited);
        }

        &:hover {
            color: var(--dit-components-color-link-hover);
        }

        &:focus,
        &:focus-visible {
            outline: none;
            border-radius: 4px;
            box-shadow: var(--dit-layout-shadow-link-focus--map);
            border: 0;
        }
    }
`;
